import { routerNavigatedAction } from '@ngrx/router-store';
import { Action, createReducer, on } from '@ngrx/store';
import { CloneApiActions, CloneUserActions } from 'src/app/admin/clone-user/store/clone.actions';
import { ClonedUser } from 'src/app/admin/models/cloned-user.model';
import { UserAccount } from 'src/app/admin/models/user-account.model';

export interface CloneState {
    employee: UserAccount[];
    clonedUser: ClonedUser;
    hasCloneRestrictedPermission?: boolean;
    cloneCoreApiPermissions?: boolean;
}

const initialState: CloneState = {
    employee: [],
    clonedUser: null,
    hasCloneRestrictedPermission: null,
    cloneCoreApiPermissions: false
};

export function cloneUserReducer(state: CloneState, action: Action) {
    return createReducer(
        initialState,
        on(CloneApiActions.getUsersByNameSuccess, (currentState, { employee }) => ({
            ...currentState,
            employee
        })),
        on(CloneApiActions.getUsersByNameFailure, (currentState) => ({
            ...currentState,
            employee: []
        })),
        on(CloneApiActions.userHasCloneRestrictedPermissionSuccess, (currentState, { hasCloneRestrictedPermission }) => ({
            ...currentState,
            hasCloneRestrictedPermission
        })),
        on(CloneApiActions.userHasCloneRestrictedPermissionFailure, (currentState) => ({
            ...currentState,
            hasCloneRestrictedPermission: null
        })),
        on(CloneApiActions.createCloneSuccess, CloneUserActions.clearCloneSuccess, (currentState, action) => ({
            ...currentState,
            clonedUser: action.clonedUser
        })),
        on(CloneApiActions.createCloneFailure, (currentState) => ({
            ...currentState,
            // On error, alternate between undefined and null to still trigger updates on consecutive errors:
            clonedUser: currentState.clonedUser === null ? undefined : null
        })),
        on(routerNavigatedAction, (currentState) => ({
            ...currentState,
            hasCloneRestrictedPermission: null,
            cloneCoreApiPermissions: false
        })),
        on(CloneUserActions.setCloneCoreApiPermissions, (currentState, { cloneCoreApiPermissions }) => ({
            ...currentState,
            cloneCoreApiPermissions
        }))
    )(state, action);
}

export function reducer(state: CloneState | undefined, action: Action) {
    return cloneUserReducer(state, action);
}
